<template>

    <!-- Page Title -->
    <section class="page-title centred" style="background-image: url(assets/images/background/page-title.jpg);">
        <div class="shape" style="background-image: url(assets/images/shape/banner-shap.png);"></div>
        <div class="auto-container">
            <div class="content-box">
                <h1>Products</h1>
                <ul class="bread-crumb clearfix">
                    <li><router-link to="/">Home</router-link></li>
                    <li>Products</li>
                </ul>
            </div>
        </div>
    </section>
    <!-- End Page Title -->

    <section class="shop-section centred">
        <div class="auto-container">
            <!-- <div class="sec-title">
                <h2>We Deliver Best Quality <br />Bottle Packs.</h2>
            </div> -->
            <div class="row clearfix">
                <div v-for="(product, index) in products" :key="index" class="col-lg-4 col-md-6 col-sm-12 shop-block">
                    <div class="shop-block-one wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500m">
                        <div class="inner-box">
                            <figure class="image-box"><img :src="product.image_280_270" alt="product"></figure>
                            <div class="lower-content">
                                <div class="shape" style="background-image: url(assets/images/shape/shape-7.png);"></div>
                                <h4><router-link :to="`/product-detail/${product.slug}`" >{{ product.name }}</router-link></h4>                                
                                <p>{{ product.short_description }}</p>
                                <div class="btn-box">
                                    <router-link :to="`/product-detail/${product.slug}`" class="theme-btn btn-two">Read More</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </section>

    <section class="testimonial-section bg-color-1" >
        <div class="shape-layer">
            <div class="shape-1" style="background-image: url(assets/images/shape/shape-8.png);"></div>
            <div class="shape-2" style="background-image: url(assets/images/shape/shape-9.png);"></div>
        </div>
        <div class="auto-container">
            <div class="sec-title text-center">
                <h2>SECTORS WE SERVE</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 content-column">
                    <p>Akshar watertech comprehensive, integrated solutions to diverse industries from automotive and textile, pharma , Ceramic and electronics, food and beverage, to power stations, refineries, fertiliser and steel plants and many more</p>
                    <p class="mt-3">We offer systems for drinking water purification, water conditioning for utilities, treatment of sewage and recycle, waste to energy solution. We also provide comprehensive O&M services and AMC contracts which eliminates operation, maintenance and supervision by the customer.</p>
                </div>
            </div>
            <div class="three-item-carousel owl-carousel owl-theme owl-dots-none owl-nav-none text-center mt-5">
                <div class="service-block-two">
                    <div class="inner-box">
                        <h4><a href="#">Textile</a></h4>
                    </div>
                </div>
                <div class="service-block-two">
                    <div class="inner-box">
                        <h4><a href="#">Pharma</a></h4>
                    </div>
                </div>
                <div class="service-block-two">
                    <div class="inner-box">
                        <h4><a href="#">Ceramic and Electronics</a></h4>
                    </div>
                </div>
                <div class="service-block-two">
                    <div class="inner-box">
                        <h4><a href="#">Food and Beverage</a></h4>
                    </div>
                </div>
                <div class="service-block-two">
                    <div class="inner-box">
                        <h4><a href="#">Power Stations</a></h4>
                    </div>
                </div>
                <div class="service-block-two">
                    <div class="inner-box">
                        <h4><a href="#">Refineries</a></h4>
                    </div>
                </div>
                <div class="service-block-two">
                    <div class="inner-box">
                        <h4><a href="#">Fertiliser</a></h4>
                    </div>
                </div>
                <div class="service-block-two">
                    <div class="inner-box">
                        <h4><a href="#">Steel Plants</a></h4>
                    </div>
                </div>
            </div>
            <!-- <div class="row clearfix text-center mt-5">
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <h4><a href="#">Textile</a></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="300ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <h4><a href="#">Pharma</a></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="600ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <h4><a href="#">Ceramic and Electronics</a></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="600ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <h4><a href="#">Food and Beverage</a></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="600ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <h4><a href="#">Power Stations</a></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="600ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <h4><a href="#">Refineries</a></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="600ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <h4><a href="#">Fertiliser</a></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="600ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <h4><a href="#">Steel Plants</a></h4>
                        </div>
                    </div>
                </div>
            </div> -->
            
        </div>
    </section>
    
</template>

<script setup>
import { onMounted } from 'vue'
import { useHead } from '@unhead/vue'
import products from '../json/products.json'

useHead({
  title: 'Products',
  meta: [
    {
      name: 'description',
      content: 'Welcome to Akshar.',
    },
  ],
})

onMounted(() => {
    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
    // Replace it: remove and re-add
    existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)

})
</script>
<style scoped>
.shop-section {    
    padding: 100px 0px 150px 0px;
}
.shop-block-one .inner-box{
    padding: 23px 40px 60px 40px;
}
.shop-block{
    margin-bottom: 30px;
}
</style>